module.exports = __webpack_public_path__ + "static/case_study_bananki_back-75932b8eb4c030223550165c752de96f.png";